import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchMarketplaceArgs } from '../api/types/marketplace.types';

import { fetchMarketplace } from '../api/marketplace.api';

export const marketplaceQueryKeys = createQueryKeys('marketplace', {
  fetchInfiniteMarketplace: ({
    contentFilters,
    locale,
    tableFilters,
  }: FetchMarketplaceArgs) => ({
    queryFn: async (context: any) => {
      return fetchMarketplace({
        ...context,
        contentFilters,
        locale,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      });
    },
    queryKey: [locale, tableFilters, contentFilters],
  }),
});
